/**
 * Route access types.
 * @type {import("./types").RouteAccessTypesInterface}
 */
const types = {
    /**
     * Accessible only for not logged in users.
     */
    RESTRICTED: "restricted",
    /**
     * Accessible for all users.
     */
    PUBLIC: "public",
    /**
     * Accessible for logged in users.
     */
    PROTECTED: "protected"
}

export default types;